<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
  ><g><g><path
    :fill="color"
    d="M12.46 10.675c.104.314-.001.764-.235.998l-.641.64c-.114.115-.45.186-.46.186a7.56 7.56 0 0 1-5.411-2.212A7.569 7.569 0 0 1 3.5 4.857s.073-.326.188-.439l.64-.64c.235-.236.685-.342 1-.237l.135.045c.314.105.644.453.731.773l.323 1.183c.087.321-.03.778-.265 1.013l-.428.427a4.543 4.543 0 0 0 3.195 3.196l.427-.428c.236-.235.693-.353 1.013-.266l1.183.324c.32.088.668.416.773.73l.045.137zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7"
  /></g></g></svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
